import { Icon } from '@/shared/ui/icon'

import cls from './Error.module.scss'

export const Error = () => (
	<div className={cls.root}>
		<Icon name="IPortNetworkErrorFill" className={cls.icon} size={64} viewBox="0 0 64 66" />
		<p className={cls.title}>Сервис авторизации в данный момент не доступен</p>
		<p className={cls.description}>Пожалуйста, повторите попытку через несколько минут</p>
	</div>
)
